module.exports = __webpack_public_path__ + "img/icon-share.92a47e14.svg";